import type { RJSFValidationError } from '@rjsf/utils';

import { INTEGRATIONS } from 'screens/Integrations/Integrations.uiCopy';

export const transformPhoneNumberPatternErrors = (
  errors: RJSFValidationError[],
) => {
  const allowedEnvironments = new Set(['sandbox', 'prerelease', 'live']);

  for (const err of errors) {
    const propertySegment = err.property?.split('.')[1];
    if (
      err.name === 'pattern' &&
      !!propertySegment &&
      allowedEnvironments.has(propertySegment)
    ) {
      err.message = INTEGRATIONS.forms.telephoneErrorMessage;
    }
  }

  return errors;
};
